<template>
  <app-page-container title="گزارش پرونده ها">
    <template v-slot:header>
      <v-col v-if="!!$route?.query?.missionId" cols="1" class="mr-n14">
        <v-btn fab dark small class="mr-n3 mt-3" color="darkColor" @click="backToSurveyReport()" elevation="0">
          <v-icon dark>mdi-arrow-right mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="4" class="mr-n9">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="1">
        <v-btn class="mx-2 mt-3" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
          <v-icon dark>mdi-filter mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1" class="mt-6 mr-n4" v-if="isSearch">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()" class="">
              mdi-filter-remove mdi-18px
            </v-icon>
          </template>
          <span>حذف فیلتر ها</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="1" class="mt-3">
        <v-btn @click="
          exportToExcel(
            misssionReportInformationTableHeaders,
            excelTableData,
            'text',
            `mission_report_${page}`,
          )
          " fab dark small color="darkColor" elevation="0">
          <v-icon dark>mdi-file-excel mdi-18px</v-icon>
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main mx-2">
        <v-col cols="12">
          <v-card elevation="0" class="card-width body-card pa-0">
            <v-card-text class="pa-0">
              <template>
                <v-data-table multi-sort hide-default-header fixed-header :item-class="getRowClass"
                  :headers="misssionReportInformationTableHeaders" :items="missionReportDataTableInfo" :page.sync="page"
                  :items-per-page="missionReportDataTableInfo.length" @contextmenu:row="rightClickHandler" height="70vh"
                  :search="searchTitle" :hide-default-footer="true" class="mission-report-table">
                  <template v-slot:header="props">
                    <app-group-table-header :headers="props.props.headers" @sort="props.on.sort"
                      @group="props.on.group" />
                  </template>
                  <template v-slot:[`item.doctorAccept`]="{ item }">
                    <v-icon color="#3BCA79" v-if="item.doctorAccept === true">
                      mdi-checkbox-marked-outline mdi-18px
                    </v-icon>
                    <v-icon color="#DA6757" v-if="item.doctorAccept === false">
                      mdi-checkbox-blank-outline mdi-18px
                    </v-icon>
                  </template>
                  <template v-slot:[`item.admissionWithOutPermission`]="{ item }">
                    <v-icon color="#3BCA79" v-if="item.admissionWithOutPermission === true">
                      mdi-checkbox-marked-outline mdi-18px
                    </v-icon>
                    <v-icon color="#DA6757" v-if="item.admissionWithOutPermission === false">
                      mdi-checkbox-blank-outline mdi-18px
                    </v-icon>
                  </template>
                  <template v-slot:[`item.hasDoctor`]="{ item }">
                    <v-tooltip top v-if="item.hasDoctor === true">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon :color="item.color" v-bind="attrs" v-on="on">
                          mdi-doctor mdi-18px
                        </v-icon>
                      </template>
                      <span>مشاوره پزشکی</span>
                    </v-tooltip>
                    <v-icon :color="item.color" v-if="item.hasDoctor === false">
                      mdi-file-document mdi-18px
                    </v-icon>
                  </template>

                  <template v-slot:[`item.result`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="custom-text2" v-bind="attrs" v-on="on">
                          {{ item.result }}
                        </div>
                      </template>
                      <span>{{ item.result }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.chiefComplant`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="custom-text2" v-bind="attrs" v-on="on">
                          {{ item.chiefComplant }}
                        </div>
                      </template>
                      <span>{{ item.chiefComplant }}</span>
                    </v-tooltip>
                  </template>

                  <template v-slot:[`item.address`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="custom-text" v-bind="attrs" v-on="on">
                          {{ item.address }}
                        </div>
                      </template>
                      <span>{{ item.address }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.diagnosis`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="custom-text" v-bind="attrs" v-on="on">
                          {{ item.diagnosis }}
                        </div>
                      </template>
                      <span>{{ item.diagnosis }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:no-data>
                    <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                  </template>
                </v-data-table>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <pagination-component ref="pagination">
            <div slot="action">
              <v-card elevation="0">
                <v-pagination class="mt-8" circle color="lightColor" v-model="page" :length="totalPages"
                  :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                  @next="next()" @previous="previous()" @input="input()"></v-pagination>
              </v-card>
            </div>
          </pagination-component>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <!--audio ***********************************************-->
        <!-- <v-dialog v-model="player" width="400px" style="overflow-x: hidden" :key="recordFile">
          <v-card width="400px">
            <v-row justify="center" style="overflow-x: hidden" no-gutters>
              <v-col cols="10" style="text-align: center" class="mt-4">
                <audio controls oncontextmenu="return false;" controlsList="nodownload" cors-anonym="true" autoplay
                  :src="recordFile" ref="audioFile"></audio>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="no-letter-space" @click="stopMusic()">بستن H</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        <v-dialog v-model="missionDetailModal" width="1300" persistent>
          <mission-report-detail-component v-if="missionDetailModal" :missionId="missionId"
            :missionPhoneId="missionPhoneId" :phoneId="phoneId"
            :patientId="patientId"></mission-report-detail-component>
        </v-dialog>

        <v-dialog width="800" v-model="showEditUserDetaiModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5 relative">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-account</v-icon>
                  <span class="modal-title-text mr-2"> اطلاعات مددجو</span>
                  <v-spacer></v-spacer>
                </v-row>
                <v-icon color="#c93b3f" size="24" class="btnClose" @click="cancelAddEditFunction()">
                  mdi-close
                </v-icon>
              </v-col>
            </v-row>

            <v-tabs v-model="activeTab" background-color="transparent" color="darkColor" grow class="custom-tabs">
              <v-tab>
                <v-icon left size="18">mdi-account-edit</v-icon>
                ویرایش اطلاعات
              </v-tab>
              <v-tab>
                <v-icon left size="18">mdi-history</v-icon>
                سابقه ویرایش‌ها
                <v-chip v-if="listEditPationts?.length" x-small color="darkColor" dark class="mr-2">
                  {{ listEditPationts.length }}
                </v-chip>
              </v-tab>
            </v-tabs>

            <v-divider></v-divider>

            <v-tabs-items v-model="activeTab">
              <v-tab-item>
                <v-card-text class="mt-5">
                  <v-row>
                    <v-col cols="4" class="mt-n2">
                      <v-checkbox v-model="userDetail.isUnknown" label="مجهول الهویه" hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="4" v-if="!userDetail.isUnknown">
                      <v-text-field hide-details dense outlined v-model="userDetail.firstName" label="نام *" clearable
                        clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-account mdi-18px"></v-text-field>
                    </v-col>
                    <v-col cols="4" v-if="!userDetail.isUnknown">
                      <v-text-field hide-details dense outlined v-model="userDetail.lastName" label="نام خانوادگی *"
                        clearable clear-icon="mdi-close-circle-outline"
                        prepend-inner-icon="mdi-account mdi-18px"></v-text-field>
                    </v-col>

                    <v-col cols="4" class="mt-n2" v-if="userDetail.isUnknown == true">
                      <v-text-field hide-details dense outlined v-model="userDetail.clothesColorAndType"
                        label="نوع و رنگ لباس*" clearable clear-icon="mdi-close-circle-outline"
                        prepend-inner-icon="mdi-receipt mdi-18px"></v-text-field>
                    </v-col>
                    <v-col cols="4" class="mt-n2" v-if="userDetail.isUnknown == true">
                      <v-text-field hide-details dense outlined v-model="userDetail.specialCharacteristic"
                        label="مشخصه خاص*" clearable clear-icon="mdi-close-circle-outline"
                        prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
                    </v-col>

                    <v-col cols="4" class="mt-n2">
                      <v-text-field hide-details dense outlined @keypress="isNumber($event)"
                        v-model="userDetail.yearOfAge" label="حدود سن (سال)" maxlength="3" clearable
                        clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
                    </v-col>
                    <v-col cols="4" class="mt-n2">
                      <v-text-field hide-details dense outlined @keypress="isNumber($event)"
                        v-model="userDetail.monthOfAge" label="حدود سن (ماه)" maxlength="2" clearable
                        clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
                    </v-col>
                    <v-col cols="4" class="mt-n2">
                      <v-row>
                        <v-col cols="3">
                          <v-checkbox class="mt-2" v-model="isChildren" label="نوزاد" hide-details></v-checkbox>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field :disabled="!isChildren" hide-details dense outlined @keypress="isNumber($event)"
                            v-model="userDetail.ageTotalDays" label="حدود سن (روز)" maxlength="2" clearable
                            clear-icon="mdi-close-circle-outline"
                            prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="4" class="mt-n2" v-if="!userDetail.isUnknown">
                      <v-text-field hide-details dense outlined @keypress="isNumber($event)" maxlength="10"
                        v-model="userDetail.nationalCode" label="کد ملی" clearable clear-icon="mdi-close-circle-outline"
                        prepend-inner-icon="mdi-card-account-details mdi-18px"></v-text-field>
                    </v-col>
                    <v-col cols="4" class="mt-n2" v-if="!userDetail.isUnknown">
                      <v-autocomplete hide-details :items="nationalityList" no-data-text="اطلاعاتی وجود ندارد" dense
                        outlined item-text="title" item-value="id" label="ملیت *" clearable
                        clear-icon="mdi-close-circle-outline" v-model="userDetail.nationality" autocomplete="off"
                        prepend-inner-icon="mdi-account-question mdi-18px"></v-autocomplete>
                    </v-col>
                    <v-col cols="4" class="mt-n2" v-if="!userDetail.isUnknown">
                      <v-autocomplete hide-details :items="genderFollowUpItems" no-data-text="اطلاعاتی وجود ندارد" dense
                        outlined item-text="title" item-value="id" label="جنسیت *" clearable
                        clear-icon="mdi-close-circle-outline" v-model="userDetail.gender" autocomplete="off"
                        prepend-inner-icon="mdi-human-male-female mdi-18px"></v-autocomplete>
                    </v-col>
                    <v-col cols="4" class="" v-if="!userDetail.isUnknown">
                      <app-date-picker label="تاریخ تولد" inputID="birthDate" :const-value="userDetail.birthDate"
                        v-model="userDetail.birthDate" />
                    </v-col>
                    <v-col cols="4"
                      v-if="userDetail.patientResult && (userDetail.patientResult?.result?.id == 1 || userDetail.patientResult?.result?.id == 11)">
                      <v-autocomplete hide-details :items="allActiveHospitals" no-data-text="اطلاعاتی وجود ندارد" dense
                        outlined item-text="title" item-value="id" label="بیمارستان *" clearable
                        clear-icon="mdi-close-circle-outline" v-model="userDetail.hospitalId" autocomplete="off"
                        prepend-inner-icon="mdi-human-male-female mdi-18px"></v-autocomplete>
                    </v-col>
                    <v-col cols="4">
                      <v-file-input hide-details label="پیوست" outlined dense v-model="imgAttach"
                        accept=".pdf,.jpg,.jpeg,.png" :rules="fileRules" prepend-icon="mdi-paperclip"
                        @change="onFileChange">
                        <template v-slot:append-outer>
                          <v-tooltip top max-width="280">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon color="#5a6379" size="20" v-bind="attrs" v-on="on" class="info-icon">
                                mdi-information-variant
                              </v-icon>
                            </template>
                            <div class="tooltip-content">
                              <div class="tooltip-title">
                                <v-icon size="14" color="white">mdi-alert-circle-outline</v-icon>
                                راهنما
                              </div>
                              <div class="tooltip-line">
                                <strong>فرمت‌های مجاز:</strong> PDF، JPG، JPEG، PNG
                              </div>
                              <div class="tooltip-line">
                                <strong>حداکثر حجم:</strong> ۳ مگابایت
                              </div>
                            </div>
                          </v-tooltip>
                        </template>
                      </v-file-input>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea hide-details type="text" clearable clear-icon="mdi-close-circle-outline"
                        v-model="userDetail.note" outlined v-on:keyup.enter="showConfirmDialogFunction('edit')"
                        label="توضیحات *" class="input-label" prepend-inner-icon="mdi-text mdi-18px" tabindex="2"
                        rows="2"></v-textarea>
                    </v-col>

                    <v-col cols="12">
                      <div class="flex justify-center items-center gap-2">
                        <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                          class="normal-letter-spacing px-12">
                          ثبت
                        </v-btn>
                        <v-btn rounded color="darkColor" outlined @click="cancelAddEditFunction()"
                          class="normal-letter-spacing px-10">
                          انصراف
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-tab-item>

              <v-tab-item>
                <v-card-text class="mt-5">
                  <div v-if="listEditPationts?.length > 0">
                    <v-row justify="start" class="pa-4">
                      <v-col cols="12" sm="12" md="6" v-for="(item, index1) in listEditPationts" :key="index1">
                        <div class="info-card">
                          <div class="info-card__header">
                            <div class="info-card__avatar">
                              <v-icon color="white" size="22">mdi-account</v-icon>
                            </div>
                            <div class="info-card__title">
                              <span class="info-card__name">
                                {{ item?.user?.firstName ?? '' }} {{ item?.user?.lastName ?? '' }}
                              </span>
                              <span class="info-card__date">
                                <v-icon size="14" color="grey">mdi-clock-outline</v-icon>
                                {{ $moment(item.creationDate).format('HH:mm:ss - jYYYY/jM/jD') }}
                              </span>
                            </div>
                          </div>

                          <div class="info-card__body">
                            <p class="info-card__text">{{ item?.note ?? '' }}</p>
                          </div>

                          <div class="info-card__divider"></div>

                          <div class="info-card__footer">
                            <div class="attach-list">
                              <div class="attach-item"
                                v-for="(attItem, indexAtt) in item?.patientModificationAttachments" :key="indexAtt"
                                @click="downloadAttachEditPatientFunction(attItem?.id, attItem?.fileExtension)">
                                <v-icon color="#17337e" size="20">mdi-file-document-check-outline</v-icon>
                                <span class="attach-name">پیوست {{ indexAtt + 1 }}</span>
                              </div>
                            </div>

                            <v-tooltip top max-width="280">
                              <template v-slot:activator="{ on, attrs }">
                                <div class="attach-add-btn" v-bind="attrs" v-on="on">
                                  <v-file-input prepend-icon="mdi-paperclip-plus mdi-20px" class="edit-img-pen" dense
                                    hide-details hide-input v-model="imgAttach_inList" accept=".pdf,.jpg,.jpeg,.png"
                                    :rules="fileRules"
                                    @change="setModificationAttachmentPatientFunction($event, item?.id, patientId)" />
                                </div>
                              </template>
                              <div class="tooltip-content">
                                <div class="tooltip-title">
                                  <v-icon size="14" color="white">mdi-alert-circle-outline</v-icon>
                                  راهنما
                                </div>
                                <div class="tooltip-line">
                                  <strong>فرمت‌های مجاز:</strong> PDF، JPG، JPEG، PNG
                                </div>
                                <div class="tooltip-line">
                                  <strong>حداکثر حجم:</strong> ۳ مگابایت
                                </div>
                              </div>
                            </v-tooltip>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>

                  <div v-else class="empty-history">
                    <v-icon size="60" color="#c3c9d6">mdi-history</v-icon>
                    <h3>بدون سابقه</h3>
                    <p>هیچ سابقه ویرایشی برای این مددجو ثبت نشده است.</p>
                  </div>
                </v-card-text>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-dialog>

        <!--users ************************************************-->
        <v-dialog width="700" v-model="missionUsersModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-3">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-account</v-icon>
                  <span class="modal-title-text mr-2">کاربران</span>
                  <v-spacer></v-spacer>
                  <v-icon class="ml-4" @click="closeUsersModal()">mdi-close</v-icon>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-4">
              <v-row>
                <v-col v-for="(item, index) in users" :key="index" :cols="item.col">
                  <v-card class="card-info-send-mission" elevation="0" height="5vh">
                    <v-card-text>
                      <v-row>
                        <span class="mt-1 send-mission-info-title-content">{{ item.title }}:</span>
                        <span class="mr-2 mt-1 send-mission-info-text-content">
                          {{ item.content }}
                        </span>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!--calls ************************************************-->
        <v-dialog width="1300" v-model="missionCallsModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-3">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-phone mdi-flip-h</v-icon>
                  <span class="modal-title-text mr-2">تماس ها</span>
                  <v-spacer></v-spacer>
                  <v-icon class="ml-4" @click="closeCallsModal()">mdi-close</v-icon>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12">
                  <template>
                    <v-data-table fixed-header :headers="misssionCallsInformationTableHeaders"
                      :items="missionCallsDataTableInfo" :items-per-page="missionCallsDataTableInfo.length"
                      height="67vh" :hide-default-footer="true" multi-sort class="elevation-0">
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer" v-bind="attrs"
                              @click="playAudioFunction(item.callLogId)" v-on="on">
                              mdi-play-circle
                            </v-icon>
                          </template>
                          <span>پخش صوت</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer"
                              @click="downloadAudioFunction(item.callLogId, item?.fromNumber)" v-bind="attrs" v-on="on">
                              mdi-tray-arrow-down
                            </v-icon>
                          </template>
                          <span>دانلود</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!--calls ************************************************-->
        <v-dialog width="1300" v-model="missionFillesModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-3">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-folder-open</v-icon>
                  <span class="modal-title-text mr-2">پیوست ها</span>
                  <v-spacer></v-spacer>
                  <v-icon class="ml-4" @click="closeAttachmentModal()">mdi-close</v-icon>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12">
                  <template>
                    <v-data-table fixed-header :headers="misssionFillesInformationTableHeaders"
                      :items="missionFillesDataTableInfo" :items-per-page="missionFillesDataTableInfo.length"
                      height="67vh" :hide-default-footer="true" multi-sort class="elevation-0">
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer" v-bind="attrs"
                              @click="showAttachment(item.filePath)" v-on="on">
                              mdi-eye
                            </v-icon>
                          </template>
                          <span>مشاهده</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer"
                              @click="downloadAttachment_NewFunction(item.filePath)" v-bind="attrs" v-on="on">
                              mdi-tray-arrow-down
                            </v-icon>
                          </template>
                          <span>دانلود</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!--Triages ************************************************-->
        <v-dialog width="1230" v-model="missionTriagesModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-3">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-file-text</v-icon>
                  <span class="modal-title-text mr-2">تریاژ تلفنی</span>
                  <v-spacer></v-spacer>
                  <v-icon class="ml-4" @click="closeTriageModal()">mdi-close</v-icon>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-4 px-10">
              <v-row>
                <v-col cols="12">
                  <template>
                    <v-expansion-panels class="expanstion-panel-container" color="#F6FBFF" flat multiple>
                      <v-expansion-panel class="expanstion-panel-each_item">
                        <v-expansion-panel-header class="expanstion-panel-each_item-header">
                          <v-row class="">
                            <v-col cols="1">
                              <v-icon dense color="#2EDF93">mdi-message-question mdi-20px</v-icon>
                            </v-col>
                            <v-col class="mr-n14">
                              <div>پرسش های کلیدی</div>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="expanstion-panel-each_item-content">
                          <v-list color="transparent">
                            <v-list-item v-for="({ question }, index) in allTriageQuestions" :key="question?.id"
                              class="">
                              <v-list-item-content class="expanstion-panel-each_item-content-list">
                                <template>
                                  <p class="text-right mb-0">
                                    {{ index + 1 }}. {{ question?.title }}
                                  </p>
                                </template>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel class="expanstion-panel-each_item">
                        <v-expansion-panel-header class="expanstion-panel-each_item-header">
                          <v-row class="">
                            <v-col cols="1">
                              <v-icon dense color="#2EDF93">mdi-message-question mdi-20px</v-icon>
                            </v-col>
                            <v-col class="mr-n14">
                              <div>پاسخ ها</div>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="expanstion-panel-each_item-content">
                          <v-list color="transparent" class="expanstion-panel-each_item-content-list">
                            <v-list-item v-for="{ answer } in transformedTriageAnswers" :key="answer?.id">
                              <v-list-item-content>
                                <template>
                                  <div class="flex gap-1 items-start">
                                    <v-icon dense small :color="answer.answerRankColor">
                                      mdi-circle mdi-16px
                                    </v-icon>
                                    <p class="text-right mb-0">
                                      {{ answer?.title }}
                                    </p>
                                  </div>
                                </template>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!--logs ************************************************-->
        <v-dialog width="1300" v-model="missionLogsModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-3">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-file-text</v-icon>
                  <span class="modal-title-text mr-2">روند پرونده</span>
                  <v-spacer></v-spacer>
                  <v-icon class="ml-4" @click="closeLogModal()">mdi-close</v-icon>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-3 log-part">
              <v-row>
                <v-col cols="12" v-for="item in missionLogsInfo" :key="item.id" class="mb-13">
                  <mission-log-component :user="item.user" :date="item.date" :note="item.note"></mission-log-component>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!--search ***********************************************-->
        <v-dialog width="850" v-model="searchModal">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-2">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-magnify</v-icon>
                  <span class="modal-title-text mr-2">جستجوی پرونده</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-12">
              <v-row>
                <v-col cols="6">
                  <v-text-field hide-details type="text" v-model="searchMissionIdentifier" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="شماره پرونده"
                    class="input-label" prepend-inner-icon="mdi-counter mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field hide-details type="text" v-model="searchFullName" dense clearable
                    :disabled="isSearchedUnknownPerson" clear-icon="mdi-close-circle-outline" outlined
                    v-on:keyup.enter="search()" label="نام و نام خانوادگی" class="input-label"
                    prepend-inner-icon="mdi-account mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-checkbox dense hide-details v-model="isSearchedUnknownPerson" label="مجهول الهویه"></v-checkbox>
                </v-col>
                <v-col cols="6">
                  <v-text-field hide-details type="text" v-model="searchMainPhoneNumber" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="شماره اصلی"
                    class="input-label" prepend-inner-icon="mdi-phone mdi-flip-h mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field hide-details type="text" v-model="searchOtherPhoneNumber" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="تلفن پیگیری"
                    class="input-label" prepend-inner-icon="mdi-phone mdi-flip-h mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field hide-details type="text" v-model="searchPhoneCode" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="کد آمبولانس"
                    class="input-label" prepend-inner-icon="mdi-ambulance mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete hide-details :items="allTagsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                    outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                    label="برچسب" v-model="searchTagId" autocomplete="off"
                    prepend-inner-icon="mdi-tag mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete hide-details :items="allResultBaseDataWithPatient" no-data-text="اطلاعاتی وجود ندارد"
                    dense outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                    label="نتیجه" v-model="searchPatientResult" autocomplete="off"
                    prepend-inner-icon="mdi-car-emergency mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete hide-details :items="triageRankItems" no-data-text="اطلاعاتی وجود ندارد" dense
                    outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                    label="اولویت" v-model="searchRank" autocomplete="off"
                    prepend-inner-icon="mdi-car-emergency mdi-18px"></v-autocomplete>
                </v-col>

                <v-col cols="6">
                  <v-autocomplete hide-details :items="allChiefComplaintsForOther" no-data-text="اطلاعاتی وجود ندارد"
                    dense outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                    label="تشخیص احتمالی پرستار" v-model="chiefComplaintChangeText" autocomplete="off"
                    prepend-inner-icon="mdi-car-emergency mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="2" class="pt-0">
                  <v-checkbox v-model="startTriage" hide-details label="تریاژ استارت"></v-checkbox>
                </v-col>
                <v-col cols="3" class="pt-0">
                  <v-checkbox v-model="currentUserReport" hide-details label="پرونده های کاربر جاری"></v-checkbox>
                </v-col>
                <v-col cols="3">
                  <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                    clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="شهر"
                    v-model="searchCityId" autocomplete="off" prepend-inner-icon="mdi-home-city mdi-18px"
                    style="font-size: 11px !important"></v-autocomplete>
                </v-col>
                <v-col cols="9">
                  <v-text-field hide-details type="text" v-model="searchAddress" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="آدرس"
                    class="input-label" prepend-inner-icon="mdi-map-marker mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field hide-details type="text" outlined id="user-moveFromStationTime"
                    ref="moveFromStationTime" dense clearable autocomplete="off"
                    @click:clear="clearDateTime('searchFromDate')" clear-icon="mdi-close-circle-outline"
                    v-model="tempSearchFromDate" @focus="showSearchFromDate = true" @click="showSearchFromDate = true"
                    label="از تاریخ" prepend-inner-icon="mdi-calendar-range mdi-18px">
                    <template slot="append">
                      <v-icon @click="showSearchFromDate = true" class="calender-background ml-n3 mt-n2" color="white">
                        mdi-calendar-range mdi-18px
                      </v-icon>
                    </template>
                  </v-text-field>
                  <date-picker :show="showSearchFromDate" simple v-model="searchFromDate" type="datetime" @open="onOpen"
                    @change="dateTimeChange('searchFromDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                    display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#moveFromStationTime-moveFromStationTime"
                    @close="showSearchFromDate = false" />
                </v-col>
                <v-col cols="6">
                  <v-text-field hide-details type="text" outlined id="user-arriveToLocationTime"
                    ref="arriveToLocationTime" dense autocomplete="off" clearable
                    @click:clear="clearDateTime('searchToDate')" clear-icon="mdi-close-circle-outline"
                    v-model="tempSearchToDate" @focus="showSearchToDate = true" @click="showSearchToDate = true"
                    label="تا تاریخ" prepend-inner-icon="mdi-calendar-range mdi-18px">
                    <template slot="append">
                      <v-icon @click="showSearchToDate = true" class="calender-background ml-n3 mt-n2" color="white">
                        mdi-calendar-range mdi-18px
                      </v-icon>
                    </template>
                  </v-text-field>
                  <date-picker :show="showSearchToDate" simple type="datetime" @open="onOpen" v-model="searchToDate"
                    @change="dateTimeChange('searchToDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                    display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#arriveToLocationTime-arriveToLocationTime"
                    @close="showSearchToDate = false" />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="search()" dark rounded tabindex="6" class="normal-letter-spacing px-12">
                جستجو
              </v-btn>
              <v-btn rounded color="darkColor" outlined tabindex="7" @click="cancelSearch()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- start triage -->
        <v-dialog width="1000" max-width="1100" v-model="isStartTriageModalOpen">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-2">
                <v-row no-gutters class="items-center">
                  <v-col cols="3" class="mr-2">{{ time }}</v-col>
                  <v-col>
                    <span class="modal-title-text ml-8 text-left">تریاژ استارت</span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="1 ml-2 d-flex justify-end">
                    <v-btn icon @click="closeStartTriageModal">
                      <v-icon>mdi-close mdi-24px</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-4">
              <v-data-table fixed-header max-height="40vh" :hide-default-footer="true"
                :headers="startTriageTableHeaders" :items="allMissionStartTriages">
                <template v-slot:[`item.date`]="{ item }">
                  <app-date-viewer :date="item?.date" />
                </template>
                <template v-slot:[`item.color`]="{ item }">
                  <div :class="startTriageColor(item?.color)">
                    {{ item?.color }}
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-dialog>

        <confirm-dialog ref="confirm">
          <v-row slot="action" no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
              style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
              بله
            </v-btn>
            <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
              @click="confirmDialogCancelFunction()">
              خیر
            </v-btn>
          </v-row>
        </confirm-dialog>

      </section>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
        <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute
          :close-on-content-click="closeOnContentClick" offset-y>
          <v-list dense>
            <v-list-item-group>
              <v-list-item v-for="(item, index) in visibleRightClickItems" :key="index" dense>
                <v-list-item-icon @click="rightClickAction(item.title)">
                  <v-icon color="darkColor">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'مشاهده پرونده' && multiDiagnosis == true">
                  <v-list-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item v-for="(sitem, index) in allPatientDiagnosis" :key="'c' + index"
                      @click="rightClickAction(item.title, sitem)">
                      <v-list-item-content>
                        <v-list-item-title class="mr-3">{{ sitem }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list-item-content>
                <v-list-item-content v-if="item.title == 'مشاهده پرونده' && !multiDiagnosis" class="mr-n6"
                  @click="rightClickAction(item.title, null)">
                  <v-list-item-title class="right-click-menu-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-content class="mr-n8 mt-n2"
                  v-if="item.title == 'مشاهده محدود پرونده' && multiDiagnosis == true">
                  <v-list-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item v-for="(sitem, index) in allPatientDiagnosis" :key="'cl' + index"
                      @click="rightClickAction(item.title, sitem)">
                      <v-list-item-content>
                        <v-list-item-title class="mr-3">{{ sitem }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list-item-content>
                <v-list-item-content v-if="item.title == 'مشاهده محدود پرونده' && !multiDiagnosis" class="mr-n6"
                  @click="rightClickAction(item.title, null)">
                  <v-list-item-title class="right-click-menu-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-content v-if="item.title == 'ویرایش اطلاعات مدد جو'" class="mr-n6"
                  @click="rightClickAction(item.title, null)">
                  <v-list-item-title class="right-click-menu-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-content v-if="item.title == 'تماس ها'" class="mr-n6"
                  @click="rightClickAction(item.title, null)">
                  <v-list-item-title class="right-click-menu-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-if="item.title == 'روند پرونده'" class="mr-n6"
                  @click="rightClickAction(item.title, null)">
                  <v-list-item-title class="right-click-menu-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-if="item.title == 'کاربران'" class="mr-n6"
                  @click="rightClickAction(item.title, null)">
                  <v-list-item-title class="right-click-menu-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-if="item.title == 'جزئیات ماموریت'" class="mr-n6"
                  @click="rightClickAction(item.title, null)">
                  <v-list-item-title class="right-click-menu-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-if="item.title == 'فایل های پیوست شده'" class="mr-n6"
                  @click="rightClickAction(item.title, null)">
                  <v-list-item-title class="right-click-menu-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-if="item.title == 'تریاژ'" class="mr-n6"
                  @click="rightClickAction(item.title, null)">
                  <v-list-item-title class="right-click-menu-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-if="item.title === 'تریاژ استارت'" class="mr-n6"
                  @click="rightClickAction(item.title, null)">
                  <v-list-item-title class="right-click-menu-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </section>
    </template>
  </app-page-container>
</template>
<script>
import PaginationComponent from '@/components/PaginationComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import AlertComponent from '@/components/AlertComponent.vue';
import MissionReportDetailComponent from '@/components/Report/Shared/MissionReportDetailComponent.vue';
import MissionLogComponent from '@/components/Report/MissionLogComponent.vue';
import AppDateViewer from '@/components/app/dateViewer.vue';
import AppGroupTableHeader from '@/components/app/table/groupableHeader.vue';

import CityMixin from '@/Mixins/BaseInformation/CityMixin.js';

import confirmDialog from '../../../components/ConfirmDialog.vue';

import AppDatePicker from '@/components/app/DatePicker.vue';

// ---------------------
import ExcelHelper from '@/Helpers/Excel.generator.helper';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import MissionReportHelper from '@/Helpers/Report/Shared/MissionReportHelper.js';
import MissionMixin from '@/Mixins/Mission/MissionMixin.js';
import MissionPhoneMixin from '@/Mixins/Mission/MissionPhonesMixin.js';
import ResultBaseDataMixin from '@/Mixins/BaseInformation/ResultBaseDataMixin';
import TagMixin from '@/Mixins/BaseInformation/TagMixin.js';
import CallMixin from '@/Mixins/Call/CallMixin.js';
import PatientMixin from '@/Mixins/Doctor/PatientMixin';
import HospitalMixin from '@/Mixins/BaseInformation/HospitalMixin';

import ChiefComplaintMixin from '@/Mixins/BaseInformation/ChiefComplaintMixin';

export default {
  name: 'MissionReport',
  title: 'گزارش پرونده ها ',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    PaginationComponent,
    AlertComponent,
    MissionReportDetailComponent,
    MissionLogComponent,
    AppPageContainer,
    AppDateViewer,
    AppGroupTableHeader,
    confirmDialog,
    AppDatePicker
  },
  mixins: [
    pagination,
    MissionReportHelper,
    ShearedMixin,
    TagMixin,
    MissionMixin,
    snackBar,
    ShearedHelper,
    MissionPhoneMixin,
    CallMixin,
    PatientMixin,
    ExcelHelper,
    ResultBaseDataMixin,
    ChiefComplaintMixin,
    CityMixin,
    HospitalMixin
  ],
  created() {
    this.$root.$refs.MissionReport = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      selectedRowId: null,
      showAddEditModal: false,
      activeTab: 0,
      fileRules: [
        (file) => {
          if (!file) return true;
          return true;
        },
        (file) => {
          if (!file) return true;
          const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
          const isValid = allowedTypes.includes(file.type);
          return isValid || 'مجاز هستند PDF، JPG، JPEG و PNG فقط';
        },
        (file) => {
          if (!file) return true;
          const maxSize = 3 * 1024 * 1024; // 3MB
          return file.size <= maxSize || 'حجم فایل نباید بیشتر از ۳ مگابایت باشد';
        },
      ],
    };
  },
  computed: {
    visibleRightClickItems() {
      return this.rightClickItems.filter(item => {
        let currentUserInfo = this.$store.state.userModule.user;
        const hasPermission5 = currentUserInfo?.permissions.some(item => item.id === 5);
        if (item.title == 'ویرایش اطلاعات مدد جو') {
          return this.patientId && hasPermission5;
        }
        return true;
      });
    },
  },
  methods: {
    mounte: function () {
      this.setPreTimes();
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getMissionReportfunction();
      this.getListOfTagsForOther();
      this.getAllResultBaseDatasWithPatientFunction();
      this.getListOfChiefComplaintsForOther();
      this.getListOfCitysForOther();
    },
    previous: function () {
      this.getMissionReportfunction();
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getMissionReportfunction();
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getMissionReportfunction();
      this.$refs.pagination.page = this.page;
    },
    startTriageColor: function (color) {
      switch (color) {
        case 'سبز':
          return 'green-start-triage';

        case 'زرد':
          return 'yellow-start-triage';

        case 'قرمز':
          return 'red-start-triage';
        default:
          return '';
      }
    },
    onFileChange(file) {
      if (!file) {
        this.imgAttach = null;
        return;
      }

      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        this.$toast?.error('مجاز هستند PDF، JPG، JPEG و PNG فقط فرمت‌های');
        this.imgAttach = null;
        return;
      }

      const maxSize = 3 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$toast?.error('حجم فایل نباید بیشتر از ۳ مگابایت باشد');
        this.imgAttach = null;
        return;
      }
    },
    getRowClass(item) {
      const myId = `${(item?.missionPhoneId ?? 0)}` + `${(item?.patientId ?? 0)}`;
      return this.selectedRowId === myId ? 'selected-row' : '';
    },
  },
  beforeDestroy() { },
};
</script>
<style lang="scss">
.custom-text {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #00102b;
  // overflow: hidden;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  width: 170px;
  max-width: 170px;
}

.custom-text2 {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #00102b;
  // overflow: hidden;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  width: 120px;
  max-width: 120px;
}

.green-start-triage {
  background-color: #a4ffcb;
  color: #212121;
  font-weight: 600;
  padding: 0.5rem;
}

.yellow-start-triage {
  color: #212121;
  background-color: #ffe290;
  font-weight: 600;
  padding: 0.5rem;
}

.red-start-triage {
  color: #212121;
  background-color: #ffafaf;
  font-weight: 600;
  padding: 0.5rem;
}

.mission-report-table {
  table {
    direction: rtl !important;
  }
}

.expanstion-panel-container {
  .expanstion-panel-each_item {
    background-color: var(--background-color) !important;
    border-radius: 14px !important;
    color: #212121;
    margin-bottom: 1.5rem;
    padding: 0 1.5rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    &-header {
      padding: 0.375rem 0;
    }

    &-content {
      border-top: 1px solid var(--dark-color);
      padding: 0.375rem 0;

      &-list {
        &-answer_bolt {
          width: 14px;
          aspect-ratio: 1/1;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>

<style scoped>
>>>.mission-report-table .selected-row {
  background-color: #e3f2fd !important;
}

>>>.mission-report-table .selected-row:hover {
  background-color: #d4e9fb !important;
}

/* ✅ برای سلول‌ها هم اعمال کن */
>>>.mission-report-table .selected-row td {
  background-color: #e3f2fd !important;
}

/* پنهان کردن کادر و خط زیر فیلد */
.edit-img-pen>>>.v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
  min-height: 0 !important;
  padding: 0 !important;
}

>>>.theme--dark.v-file-input .v-file-input__text {
  color: black !important;
}

.edit-img-pen>>>.v-input__slot::before,
.edit-img-pen>>>.v-input__slot::after {
  display: none !important;
}

/* حذف فاصله‌های اضافی */
.edit-img-pen>>>.v-input__control {
  min-height: 0 !important;
}

/* استایل آیکون */
.edit-img-pen>>>.v-input__prepend-outer {
  margin: 0 !important;
  cursor: pointer;
}

.edit-img-pen>>>.v-input__prepend-outer .v-icon {
  color: #17337e !important;
  transition: transform 0.2s ease, background 0.2s ease;
  padding: 6px;
  border-radius: 50%;
}

.edit-img-pen>>>.v-input__prepend-outer .v-icon:hover {
  background: rgba(23, 51, 126, 0.1);
  transform: scale(1.15);
}
</style>


<style scoped>
.info-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(23, 51, 126, 0.08);
  border: 1px solid #e8edf7;
  padding: 16px 18px;
  transition: box-shadow 0.25s ease, transform 0.25s ease;
  direction: rtl;
}

/* .info-card:hover {
  box-shadow: 0 8px 22px rgba(23, 51, 126, 0.15);
  transform: translateY(-2px);
} */

.info-card__header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.info-card__avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2a4ca8, #17337e);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.info-card__title {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.info-card__name {
  font-size: 14px;
  font-weight: 700;
  color: #17337e;
}

.info-card__date {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  color: #7a839a;
}

.info-card__body {
  margin-top: 12px;
}

.info-card__text {
  font-size: 12.5px;
  color: #5a6379;
  line-height: 1.9;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.info-card__divider {
  height: 1px;
  background: #eef2f9;
  margin: 14px 0;
}

.info-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.attach-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
}

.attach-item {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f3f6fd;
  border: 1px solid #e0e7f6;
  border-radius: 8px;
  padding: 5px 10px;
  transition: background 0.2s ease;
  cursor: pointer;
}

.attach-item:hover {
  background: #e8effc;
}

.attach-name {
  font-size: 11.5px;
  color: #3c465e;
}

.attach-close {
  cursor: pointer;
  transition: transform 0.15s ease;
}

.attach-close:hover {
  transform: scale(1.15);
}

.attach-add-btn {
  background: #f3f6fd !important;
  border: 1px dashed #b9c8e8 !important;
  border-radius: 8px !important;
  flex-shrink: 0;
}

.attach-add-btn:hover {
  background: #e8effc !important;
}
</style>

<style scoped>
.btnClose {
  position: absolute !important;
  left: 15px;
  top: 20px;
}

.dialog-part-divider-text {
  color: #504f4f;
  font-size: 14px;
  font-weight: 600;
}

.table-card {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
  border-left: 2px solid #0f7af4 !important;
  border-right: 2px solid #0f7af4 !important;
  border-bottom: 2px solid #0f7af4 !important;
  border-top: none !important;
}

.header-title-content {
  color: white !important;
  font-size: 14px;
}

.header-title {
  margin-top: 2vh !important;
}

.modal-icon {
  margin-top: -7vh !important;
  margin-right: -1vh !important;
}

.table-status-text {
  font-size: 12px;
  margin-top: 2px !important;
}

.v-input--switch.v-input--dense.v-input--switch--inset .v-input--switch__track {
  height: 16.5px !important;
  width: 38px !important;
}

.v-input--switch.v-input--dense .v-input--switch__thumb {
  height: 12px !important;
  width: 12px !important;
}

.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.inside-cards {
  border: 1px solid var(--dark-color) !important;
  overflow-y: auto !important;
}

.dialog-part-divider-text {
  color: #212121;
  font-size: 14px;
  font-weight: 600;
}

.chip-text {
  color: var(--dark-color) !important;
}

>>>.password.v-text-field__slot {
  font-family: 'password' !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

.card-info-send-mission {
  border-right: 3px solid var(--dark-color) !important;
  border-left: 3px solid var(--dark-color) !important;
  border-top: 2px solid var(--background-color) !important;
  border-bottom: 2px solid var(--background-color) !important;
  border-radius: 10px !important;
}

.send-mission-info-title-content {
  color: #212121 !important;
  font-weight: 600;
  font-size: 14px;
}

.send-mission-info-text-content {
  color: #212121 !important;
  font-weight: 400;
  font-size: 12px;
}

.log-part {
  height: 63vh;
  overflow-y: auto;
  overflow-x: hidden;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>


<style scoped>
.custom-tabs {
  border-bottom: 1px solid #e3e9f5;
}

.custom-tabs>>>.v-tab {
  font-size: 13px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
}

.custom-tabs>>>.v-tab--active {
  font-weight: 700;
}

.empty-history {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #98a0b3;
  text-align: center;
}

.empty-history h3 {
  margin-top: 16px;
  font-size: 16px;
  color: #5a6379;
}

.empty-history p {
  margin-top: 6px;
  font-size: 12.5px;
  color: #9aa3b8;
}

<style scoped>.info-icon {
  cursor: help;
  transition: color 0.2s ease, transform 0.15s ease;
}

.info-icon:hover {
  color: #17337e !important;
  transform: scale(1.15);
}

.tooltip-content {
  padding: 4px 0;
  text-align: right;
  direction: rtl;
}

.tooltip-title {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 12px;
}

.tooltip-line {
  font-size: 12px;
  line-height: 1.8;
}
</style>
